/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Ocop_Level_ProvincialInputs */

const vi_shop_home_ocop_level_provincial = /** @type {(inputs: Shop_Home_Ocop_Level_ProvincialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấp tỉnh`)
};

/**

* @param {Shop_Home_Ocop_Level_ProvincialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_level_provincial = /** @type {((inputs?: Shop_Home_Ocop_Level_ProvincialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_Level_ProvincialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_level_provincial(inputs)
});